import { render, staticRenderFns } from "./chart4.vue?vue&type=template&id=4b569112&scoped=true&"
import script from "./chart4.vue?vue&type=script&lang=js&"
export * from "./chart4.vue?vue&type=script&lang=js&"
import style0 from "./chart4.vue?vue&type=style&index=0&id=4b569112&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b569112",
  null
  
)

export default component.exports